/**
 * Lectures arrive as one flat list, already in display order (chapter by
 * chapter, ungrouped lectures last). Screens show them as sections, so this
 * turns the flat list into `[{ chapter, lectures }]`.
 *
 * `chapter` is null for the final block of lectures that belong to no chapter
 * (or to a chapter the response did not include). Chapters without lectures
 * are kept so the owner can still see and fill them; an empty ungrouped block
 * is dropped.
 *
 * @param {Array} chapters  chapters in display order
 * @param {Array} lectures  lectures in display order
 * @returns {Array<{chapter: Object|null, lectures: Array}>}
 */
export const groupLecturesByChapter = (chapters = [], lectures = []) => {
    const byChapter = new Map(
        chapters.map((chapter) => [String(chapter.chapter_id), []])
    )
    const ungrouped = []

    lectures.forEach((lecture) => {
        const bucket =
            lecture.chapter_id === null || lecture.chapter_id === undefined
                ? null
                : byChapter.get(String(lecture.chapter_id))
        if (bucket) {
            bucket.push(lecture)
        } else {
            ungrouped.push(lecture)
        }
    })

    const sections = chapters.map((chapter) => ({
        chapter,
        lectures: byChapter.get(String(chapter.chapter_id))
    }))

    if (ungrouped.length) {
        sections.push({ chapter: null, lectures: ungrouped })
    }
    return sections
}

/**
 * A preview lecture plays for anyone signed in; every other lecture needs an
 * enrolment. The server's `locked` flag wins when it is sent.
 */
export const isLectureLocked = (lecture, enrolled) => {
    if (enrolled) return false
    if (typeof lecture?.locked === "boolean") return lecture.locked
    return !lecture?.is_preview
}
